import * as React from 'react'
import { observer } from 'mobx-react'
import JobViewModel from '../JobViewModel'
import {
  Dialog,
  DialogButton,
  DialogButtonGroup,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogIllustration,
  DialogTitle,
} from 'components/Dialog'
import { DateInputContainer, Form, FormRow } from 'components/inputs'
import { useBrandingSettings } from 'hooks/branding'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: JobViewModel
}

export default observer(function StartDateDialog({ vm }: Props) {
  const { corporateMode } = useBrandingSettings()
  return (
    <Dialog
      showing={vm.startDateVM.showing}
      onClose={!vm.startDateVM.save.pending && vm.startDateVM.close}
    >
      <Form onSubmit={() => vm.startDateVM.save()}>
        <DialogHeader>
          {!corporateMode && (
            <DialogIllustration
              src={require('assets/images/img_start-date.svg')}
              alt="Woman changing the date on a calendar"
            />
          )}
          <DialogTitle>Change Start Date</DialogTitle>
          <DialogDescription>Edit the start date.</DialogDescription>
        </DialogHeader>
        <DialogContent>
          {/* <FormRow>
              <TextInputContainer
                model={vm.startDateVM}
                field="reason"
                label="Reason"
                disabled={vm.startDateVM.save.pending}
                placeholder="e.g. the start date was wrong"
                help="Specify why you are making this change."
              />
            </FormRow> */}
          <FormRow>
            <DateInputContainer
              model={vm.startDateVM}
              field="startDate"
              label="Start Date"
              disabled={vm.startDateVM.save.pending}
              placeholder=""
              minDate={new Date()}
              help="This job will not be available for pickup until this date."
            />
          </FormRow>
        </DialogContent>
        <DialogFooter bordered>
          <DialogButtonGroup>
            <DialogButton
              disabled={vm.startDateVM.save.pending}
              onClick={vm.startDateVM.close}
              type="default"
            >
              Cancel
            </DialogButton>
            <DialogButton
              submit
              loading={vm.startDateVM.save.pending}
              type="primary"
              disabled={
                vm.startDateVM.save.pending || !vm.startDateVM.canSaveStartDate
              }
            >
              Save
            </DialogButton>
          </DialogButtonGroup>
        </DialogFooter>
      </Form>
    </Dialog>
  )
})
